module.exports = __webpack_public_path__ + "img/graph-active.0ab72aa4.svg";